module.exports = __webpack_public_path__ + "img/ic_more.944a2e07.svg";